import React from 'react';

// panel-form-inner_item(法人ログイン用)
function getDesign({messageListLogin, errMap, state, handleChangeMethod, swhichPwdShowMethod, handleKeyPressMethod, loginMethod}) {

  // 言語別リンクの設定
  let managerUrl = "";
  let selfEmployeeUrl = "";

  // 日の場合
  if(sessionStorage.getItem('lang') === 'ja'){
    managerUrl = process.env.REACT_APP_URL_NOTICE_MANAGER_LOGIN_JA;
    selfEmployeeUrl = process.env.REACT_APP_URL_NOTICE_SELF_EMPLOYEE_LOGIN_JA;
  // 英の場合
  }else{
    managerUrl = process.env.REACT_APP_URL_NOTICE_MANAGER_LOGIN_EN;
    selfEmployeeUrl = process.env.REACT_APP_URL_NOTICE_SELF_EMPLOYEE_LOGIN_EN;
  }

  return (
    <form name="dummy" id="JS_jmbForm">
      {/* 画面項目表示部 */}
      {/* ID */}
      <div className="panel-form-inner_parts">                
            <p className="form-label"><label htmlFor="LA_input-number-01">{messageListLogin.itemId}</label></p>
            <input type="text" id="LA_input-number-01" name="id" 
              className={ errMap && errMap.errorId ==='id' ? "form-txt js-form-validate-blank JS_jmbNo is-blank is-error" : 
              "form-txt js-form-validate-blank JS_jmbNo is-blank"} 
              maxLength="8" placeholder="" aria-invalid={ errMap && errMap.errorId ==='id' ? "true" : "false"} 
              value={state.id} onChange={handleChangeMethod}/>
      </div>

      {/* パスワード */}
      <div className="panel-form-inner_parts">
        <p className="form-label"><label htmlFor="LA_input-password">{messageListLogin.itemPassword}</label></p>
        <input type={ state.showPwd ? "text" : "password"} id="LA_input-password" name="password"
          className={ errMap && errMap.errorId === 'password' ? "form-txt js-form-validate-blank JS_jmbPass is-blank is-error" : 
          "form-txt js-form-validate-blank JS_jmbPass is-blank"} 
          maxLength="256" placeholder="" aria-invalid={ errMap && errMap.errorId === 'password' ? "true" : "false"}
          value={state.password} onChange={handleChangeMethod}
          onKeyPress={handleKeyPressMethod}/>

        {/* パスワードを表示する */}
        <span className="form-checkbox _block">
          <input type="checkbox" id="LA_form-checkbox-01" name="__dummy__" aria-controls="LA_input-password" onChange={swhichPwdShowMethod}/>
          <label htmlFor="LA_form-checkbox-01" className="form-checkbox_item is-blank">{messageListLogin.guideMessage001}</label>
        </span>
      </div>

      {/* 操作ボタン表示部 */}
      <div className="btn-wrap">
        <div>
          <button type="button" name="__dummy__" className="btn" onClick={loginMethod}>{messageListLogin.buttonLogin}</button>
        </div>
        <p className="mgt-16">{messageListLogin.guideMessage002}</p>
      </div>

      {/* リンク表示部 */}
      <div className="form-box-wrap">
        <p className="form-table_txt mb-form-label">
          <a href={managerUrl} className="link-txt _other" target="otherwindow">
            <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.guideNewWindow} className="icon-blank"/>
              {messageListLogin.linkManagerLogin}
          </a>
        </p>
        <p className="form-table_txt mb-form-label">
          <a href={selfEmployeeUrl} className="link-txt _other" target="otherwindow">
            <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.guideNewWindow} className="icon-blank"/>
              {messageListLogin.linkSelfLogin}
          </a>
        </p>
      </div>

    </form>
  );
}

export {getDesign}